module.exports = __webpack_public_path__ + "img/Abkhazia.8d249c56.svg";